
<div class="menu-container__content">
  <div *ngFor="let items of filteredMenuHeaderItems; index as i; trackBy: trackByIndex ; let first= first;"  [ngClass]="{ first: first }">
    <a [routerLink]="items.path">
      <app-button [ngClass]="selectedTabs(items.description, first)" text={{items.description}} (onClick)="onHeaderMenuClick(items)">
      </app-button>
    </a>
  </div>
</div>

<div>
  <app-sub-menu [menuItems]="menuItems"></app-sub-menu>
</div>



